import { render, staticRenderFns } from "./desgloselibro.vue?vue&type=template&id=2aaa9ffc"
import script from "./desgloselibro.vue?vue&type=script&lang=js"
export * from "./desgloselibro.vue?vue&type=script&lang=js"
import style0 from "./desgloselibro.vue?vue&type=style&index=0&id=2aaa9ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports